module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAMCAMAAACOacfrAAAAM1BMVEUAAABHXXdHXXdHXXdHXXdHXXdHXXdHXXdHXXdHXXdHXXdHXXdHXXdHXXdHXXdHXXdHXXdie4Y6AAAAEXRSTlMA/igN8uzEvLatm4l2ZFJDNdwaCoIAAABBSURBVAjXZY5JCgAgDAON+67/f62tPYg6h4FAaaI22msRMx2iiBgWwWxR6EAyLA4NyCKiAkX0pufy/nI3/O1n2QLCsAJRG0Y+nwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./components/Icon/images/icon_fold.png
// module id = j3Vr
// module chunks = 9